// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipe-card {
  background: var(--secondary-bg);
  border-radius: var(--border-radius);
  overflow: hidden;
  transition: transform var(--transition-speed) ease, box-shadow var(--transition-speed) ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.recipe-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.recipe-card-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.recipe-card-image {
  position: relative;
  padding-top: 56.25%; /* 16:9 aspect ratio */
  overflow: hidden;
}

.recipe-card-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform var(--transition-speed) ease;
}

.recipe-card:hover .recipe-card-image img {
  transform: scale(1.05);
}

.recipe-card-content {
  padding: 1.5rem;
}

.recipe-card-title {
  font-size: 1.25rem;
  margin: 0 0 1rem;
  color: var(--secondary-text);
  font-weight: bold;
}

.recipe-card-excerpt {
  font-size: 0.9rem;
  color: var(--secondary-text);
  margin-bottom: 1rem;
  line-height: 1.5;
}

.recipe-card-excerpt p {
  margin: 0;
}

.recipe-card-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: var(--secondary-text);
}

.recipe-card-date {
  color: var(--accent-color);
}

.recipe-card-categories {
  display: flex;
  gap: 0.5rem;
}

.recipe-card-category {
  background-color: var(--accent-color);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;
  font-size: 0.7rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .recipe-card-content {
    padding: 1rem;
  }

  .recipe-card-title {
    font-size: 1.1rem;
  }

  .recipe-card-excerpt {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .recipe-card-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/RecipeCard.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,2FAA2F;EAC3F,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,sBAAsB;EAC3C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF","sourcesContent":[".recipe-card {\n  background: var(--secondary-bg);\n  border-radius: var(--border-radius);\n  overflow: hidden;\n  transition: transform var(--transition-speed) ease, box-shadow var(--transition-speed) ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.recipe-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.recipe-card-link {\n  text-decoration: none;\n  color: inherit;\n  display: block;\n}\n\n.recipe-card-image {\n  position: relative;\n  padding-top: 56.25%; /* 16:9 aspect ratio */\n  overflow: hidden;\n}\n\n.recipe-card-image img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform var(--transition-speed) ease;\n}\n\n.recipe-card:hover .recipe-card-image img {\n  transform: scale(1.05);\n}\n\n.recipe-card-content {\n  padding: 1.5rem;\n}\n\n.recipe-card-title {\n  font-size: 1.25rem;\n  margin: 0 0 1rem;\n  color: var(--secondary-text);\n  font-weight: bold;\n}\n\n.recipe-card-excerpt {\n  font-size: 0.9rem;\n  color: var(--secondary-text);\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n.recipe-card-excerpt p {\n  margin: 0;\n}\n\n.recipe-card-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.8rem;\n  color: var(--secondary-text);\n}\n\n.recipe-card-date {\n  color: var(--accent-color);\n}\n\n.recipe-card-categories {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.recipe-card-category {\n  background-color: var(--accent-color);\n  color: white;\n  padding: 0.25rem 0.5rem;\n  border-radius: 1rem;\n  font-size: 0.7rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .recipe-card-content {\n    padding: 1rem;\n  }\n\n  .recipe-card-title {\n    font-size: 1.1rem;\n  }\n\n  .recipe-card-excerpt {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .recipe-card-meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
